import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      beforeEnter (to, from, next) {
        if (from.name === 'End') {
          to.meta.skip = true
        }
        next()
      },
    },
    {
      path: '/TitlePage/:id',
      name: 'TitlePage',
      component: () =>
        import(/* webpackChunkName: "view" */ './views/TitlePage'),
    },
    {
      path: '/Start',
      name: 'Start',
      component: () =>
        import(/* webpackChunkName: "view" */ './views/Start'),
    },
    {
      path: '/Experience',
      name: 'Experience',
      component: () =>
        import(/* webpackChunkName: "view" */ './views/Experience'),
    },
    {
      path: '/Part01',
      redirect: '/Part01/Nav',
      name: 'Part01',
      component: () =>
        import(/* webpackChunkName: "view" */ './views/Part01'),
      children: [
        {
          path: 'Nav',
          name: 'Nav',
          component: () =>
            import(/* webpackChunkName: "view" */ './views/Part01/Nav'),
        },
        {
          path: 'Island',
          name: 'Island',
          component: () =>
            import(/* webpackChunkName: "view" */ './views/Part01/Island'),
          beforeEnter (to, from, next) {
            if (from.name === 'Tunnel') {
              to.meta.back = true
            }
            next()
          },
        },
        {
          path: 'Tunnel',
          name: 'Tunnel',
          component: () =>
            import(/* webpackChunkName: "view" */ './views/Part01/Tunnel'),
          beforeEnter (to, from, next) {
            if (from.name === 'Bridge') {
              to.meta.back = true
            }
            next()
          },
        },
        {
          path: 'Bridge',
          name: 'Bridge',
          component: () =>
            import(/* webpackChunkName: "view" */ './views/Part01/Bridge'),
        },
      ],
    },
    {
      path: '/Part02',
      name: 'Part02',
      component: () =>
        import(/* webpackChunkName: "view" */ './views/Part02'),
    },
    {
      path: '/Part03',
      name: 'Part03',
      component: () =>
        import(/* webpackChunkName: "view" */ './views/Part03'),
    },
    {
      path: '/Part04',
      redirect: '/Part04/Representative',
      name: 'Part04',
      component: () =>
        import(/* webpackChunkName: "view" */ './views/Part04'),
      children: [
        {
          path: 'Representative',
          name: 'Representative',
          component: () =>
            import(/* webpackChunkName: "view" */ './views/Part04/Representative'),
        },
        {
          path: 'Portrait',
          name: 'Portrait',
          component: () =>
            import(/* webpackChunkName: "view" */ './views/Part04/Portrait'),
        },
        {
          path: 'Institution',
          name: 'Institution',
          component: () =>
            import(/* webpackChunkName: "view" */ './views/Part04/Institution'),
        },
      ],
    },
    {
      path: '/Part05',
      name: 'Part05',
      component: () =>
        import(/* webpackChunkName: "view" */ './views/Part05'),
    },
    {
      path: '/End',
      name: 'End',
      component: () =>
        import(/* webpackChunkName: "view" */ './views/End'),
    },
    {
      path: '/Interact',
      name: 'Interact',
      component: () =>
        import(/* webpackChunkName: "view" */ './views/Interact'),
    },
    {
      path: '/DynamicPicture',
      name: 'DynamicPicture',
      component: () =>
        import(/* webpackChunkName: "view" */ './views/SubPage/DynamicPicture'),
    },
  ],
})
